import {
  containsHyphenInQuote,
  returnFractionString,
} from "@/lib/businessRules/dollarFractionBusinessRule";
import { QuoteSide } from "@/lib/interfaces and Enums/ENUMQuoteSide";
import { ExecutionRequestQuoteLeg } from "@/lib/interfaces and Enums/InterfaceExecutionRequestQuoteLeg";
import { generateToastMessageForTradeFlowErrors } from "@/lib/notifications/toastNotificationHelpers";
import tradeDataStore from "@/store/tradeDataStore";
import {
  ER_LEVEL_FLASH_ID,
  returnMissingQuoteCellsFromTradeJSON,
  returnMissingTwoWayQuoteCellsFromTradeJSON,
  triggerValidationFlash,
} from "./quoteFlashHelper";

// interface blockValues {
//   quoteSide: QuoteSide;
//   blockId: any;
//   bid: any;
//   ask: any;
//   mid: any;
//   fraction: any;
//   notation: any;
//   size: any;
//   effectiveDate: any;
// }
interface quoteAndExecuteJSON {
  esid: any;
  executionRequest: {
    executionRequestId: any;
    bid: string;
    bidFraction: string;
    ask: string;
    askFraction: string;
    mid: string;
    midFraction: string;
    fraction: any;
    notation: any;
    expiryPeriod: any;
    expiryPeriodType: any;
    quoteSideER: QuoteSide; // Will be ignored by backend.
    unwind: boolean;
  };
  blocks?: Partial<ExecutionRequestQuoteLeg>[]; // Should this be 'block values'?
}

// write a function here to to split the - value (possible to use the ones already done??)
// Put the start of the string on the bid/ask/mid
// Put the end of the string on fraction.

function returnQutoeValue(
  quoteSideRequested: any,
  data: any,
  isWholeValue: boolean = true,
) {
  const quoteValue = data[quoteSideRequested];

  if (quoteValue === "" || quoteValue == null) {
    return null;
  }
  const valueToCheck = quoteValue.toString();

  if (containsHyphenInQuote(valueToCheck)) {
    return returnFractionString(quoteValue, isWholeValue);
  }
  if (!isWholeValue) {
    return null; // if there is no - and the function is not generating the fraction value, return empty.
  }
  return quoteValue;
}

export function generateTradeJSON(data: any) {
  const ESTradeToQuote = tradeDataStore
    .getState()
    .tradeData.find((trade) => trade.esid == data.esid);

  const tradeJSONQuoted: quoteAndExecuteJSON = {
    esid: ESTradeToQuote?.esid,
    executionRequest: {
      executionRequestId: ESTradeToQuote?.executionRequestId,
      notation: ESTradeToQuote?.notationER, // not sure about this one.
      bid: returnQutoeValue("bid", data),
      bidFraction: returnQutoeValue("bid", data, false),
      ask: returnQutoeValue("ask", data),
      askFraction: returnQutoeValue("ask", data, false),
      mid: returnQutoeValue("mid", data),
      midFraction: returnQutoeValue("mid", data, false),
      fraction: data?.fraction,
      quoteSideER: data.quoteSideER, // Use the quote side - this will be different on trades from the OP and RP side.??
      expiryPeriod: data?.expiryPeriod,
      expiryPeriodType: data?.expiryPeriodType,
      unwind: data.unwind, // Unwind adjusted to be mandatory
    },
    blocks: ESTradeToQuote?.legs?.map(
      (block: Partial<ExecutionRequestQuoteLeg>) => ({
        // Front end sends blocks to backend, however, they arrive as legs.
        size: block.quotedSize,
        blockId: block.blockId,
        bid: returnQutoeValue("bid", block),
        bidFraction: returnQutoeValue("bid", block, false),
        ask: returnQutoeValue("ask", block),
        askFraction: returnQutoeValue("ask", block, false),
        mid: returnQutoeValue("mid", block),
        midFraction: returnQutoeValue("mid", block, false),
        fraction: block.fraction,
        notation: block.notation,
        effectiveDate: block.settlementDate
          ? block.settlementDate
          : "0001-01-01",
        quoteSide: block.quoteSide,
        unwind: block.unwind,
        bidTransactionFee: block.bidTransactionFee, // Check this has no implication to NON NPV trades
        askTransactionFee: block.askTransactionFee, // Check this has no implication to NON NPV trades
      }),
    ),
  };
  return tradeJSONQuoted;
}

// Use the nomral process of generatingTradeMessages Rather than a bespoke process for 2 extra fields.
// export function generateNPVTradeJSON(data: any) {
//   let ESTradeToQuote = tradeDataStore
//     .getState()
//     .tradeData.find((trade) => trade.esid == data.esid);

//   let tradeJSONQuoted: quoteAndExecuteJSON = {
//     esid: ESTradeToQuote?.esid,
//     executionRequest: {
//       executionRequestId: ESTradeToQuote?.executionRequestId,
//       notation: ESTradeToQuote?.notationER, // not sure about this one.
//       bid: returnQutoeValue("bid", data),
//       bidFraction: returnQutoeValue("bid", data, false),
//       ask: returnQutoeValue("ask", data),
//       askFraction: returnQutoeValue("ask", data, false),
//       mid: returnQutoeValue("mid", data),
//       midFraction: returnQutoeValue("mid", data, false),
//       fraction: data?.fraction,
//       quoteSideER: data.quoteSideER, // Use the quote side - this will be different on trades from the OP and RP side.??
//       expiryPeriod: data?.expiryPeriod,
//       expiryPeriodType: data?.expiryPeriodType,
//       unwind: data?.unwind,
//     },
//     blocks: ESTradeToQuote?.legs?.map(
//       (block: Partial<ExecutionRequestQuoteLeg>) => ({
//         // Front end sends blocks to backend, however, they arrive as legs.
//         size: block.quotedSize,
//         blockId: block.blockId,
//         bid: returnQutoeValue("bid", block),
//         bidFraction: returnQutoeValue("bid", block, false),
//         ask: returnQutoeValue("ask", block),
//         askFraction: returnQutoeValue("ask", block, false),
//         mid: returnQutoeValue("mid", block),
//         midFraction: returnQutoeValue("mid", block, false),
//         fraction: block.fraction,
//         notation: block.notation,
//         effectiveDate: block.settlementDate
//           ? block.settlementDate
//           : "0001-01-01",
//         quoteSide: block.quoteSide,
//         bidTransactionFee: block.bidTransactionFee,
//         askTransactionFee: block.askTransactionFee,
//       }),
//     ),
//   };
//   return tradeJSONQuoted;
// }

// ----- ----- ----- -----   Loop blocks   ----- ----- ----- ----- ----- ----- //

function checkAllBlocksAreQuoted(tradeJSONQuoted: any): boolean {
  let areAllBlocksQuoted = true;

  tradeJSONQuoted?.blocks?.forEach((block: any) => {
    if (block.quoteSide == QuoteSide.Bid) {
      if (block.bid == undefined) {
        areAllBlocksQuoted = false;
      }
    } else if (block.quoteSide == QuoteSide.Ask) {
      if (block.ask == undefined) {
        areAllBlocksQuoted = false;
      }
    }
  });

  return areAllBlocksQuoted;
}

export function checkAllBlocksAreQuotedDetailedResult(tradeJSONQuoted: any) {
  const detailedBlockData = {
    areAllBlocksQuoted: true,
    oneBlockWasQuoted: false,
    amountOfBlocksLeftUnquoted: 0, // added for RP when executing trades. Cube can calculate 1 missing value.
  };
  tradeJSONQuoted?.blocks?.forEach((block: any) => {
    if (block.quoteSide == QuoteSide.Bid) {
      if (block.bid == undefined || block.bid == null) {
        detailedBlockData.amountOfBlocksLeftUnquoted++;
        detailedBlockData.areAllBlocksQuoted = false;
      } else {
        detailedBlockData.oneBlockWasQuoted = true;
      }
    } else if (block.quoteSide == QuoteSide.Ask) {
      if (block.ask == undefined || block.ask == null) {
        detailedBlockData.amountOfBlocksLeftUnquoted++;
        detailedBlockData.areAllBlocksQuoted = false;
      } else {
        detailedBlockData.oneBlockWasQuoted = true;
      }
    }
  });
  return detailedBlockData;
}

// INVERT The above function for Two-Way quotes:
export function checkAllBlocksAreQuotedDetailedResultInvertedForShownTwoWay(
  tradeJSONQuoted: any,
) {
  const detailedBlockData = {
    areAllBlocksQuoted: true,
    oneBlockWasQuoted: false,
    amountOfBlocksLeftUnquoted: 0, // added for RP when executing trades. Cube can calculate 1 missing value.
  };
  tradeJSONQuoted?.blocks?.forEach((block: any) => {
    if (block.quoteSide == QuoteSide.Bid) {
      if (block.ask == undefined || block.ask == null) {
        // Checking the inverse
        detailedBlockData.amountOfBlocksLeftUnquoted++;
        detailedBlockData.areAllBlocksQuoted = false;
      } else {
        detailedBlockData.oneBlockWasQuoted = true;
      }
    } else if (block.quoteSide == QuoteSide.Ask) {
      if (block.bid == undefined || block.bid == null) {
        // Checking the inverse
        detailedBlockData.amountOfBlocksLeftUnquoted++;
        detailedBlockData.areAllBlocksQuoted = false;
      } else {
        detailedBlockData.oneBlockWasQuoted = true;
      }
    }
  });
  return detailedBlockData;
}

// The outgoing trade data uses blocks. Where the returned data uses legs. This is similar to the function above but able to use the leg data.

export function checkAllLegsAreQuotedDetailedResult(er: any) {
  // type is the ER level.
  const detailedBlockData = {
    areAllBlocksQuoted: true,
    oneBlockWasQuoted: false,
    amountOfBlocksLeftUnquoted: 0, // added for RP when executing trades. Cube can calculate 1 missing value.
  };
  if (er?.legs) {
    er?.legs?.forEach((block: any) => {
      if (block.quoteSide == QuoteSide.Bid) {
        if (block.bid == undefined || block.bid == null || block.bid == "") {
          detailedBlockData.amountOfBlocksLeftUnquoted++;
          detailedBlockData.areAllBlocksQuoted = false;
        } else {
          detailedBlockData.oneBlockWasQuoted = true;
        }
      } else if (block.quoteSide == QuoteSide.Ask) {
        if (block.ask == undefined || block.ask == null || block.ask == "") {
          detailedBlockData.amountOfBlocksLeftUnquoted++;
          detailedBlockData.areAllBlocksQuoted = false;
        } else {
          detailedBlockData.oneBlockWasQuoted = true;
        }
      }
    });
  }
  return detailedBlockData;
}
// ----- ----- ----- ----- ----- ----- ----- ----- ----- ----- ----- ----- //
// ----- ----- ----- -----   QUOTING   ----- ----- ----- ----- ----- ----- //
// ----- ----- ----- ----- ----- ----- ----- ----- ----- ----- ----- ----- //

export function quoteSynRepo(tradeJSONQuoted: any) {
  if (tradeJSONQuoted.executionRequest.quoteSideER == QuoteSide.Ask) {
    if (tradeJSONQuoted.executionRequest.ask == undefined) {
      generateToastMessageForTradeFlowErrors({
        action: "quoteSynRepo",
        outcome: "noAskquoteSideER", // ASK
      });
      triggerValidationFlash([{
        esid: tradeJSONQuoted.esid,
        blockId: ER_LEVEL_FLASH_ID,
        field: "quote",
        quoteSide: "ask",
      }]);
      return false;
    } else {
      return true; // True will trigger API call.
    }
  } else if (tradeJSONQuoted.executionRequest.quoteSideER == QuoteSide.Bid) {
    if (
      tradeJSONQuoted.executionRequest.bid == undefined ||
      tradeJSONQuoted.executionRequest.bid == null
    ) {
      generateToastMessageForTradeFlowErrors({
        action: "quoteSynRepo",
        outcome: "noBidquoteSideER", // BID
      });
      triggerValidationFlash([{
        esid: tradeJSONQuoted.esid,
        blockId: ER_LEVEL_FLASH_ID,
        field: "quote",
        quoteSide: "bid",
      }]);
      return false;
    } else {
      return true; // True will trigger API call.
    }
  }

  return false;
}
export function quoteValidationTwoWayRepo(tradeJSONQuoted: any) {
  if (
    tradeJSONQuoted.executionRequest.bid == undefined ||
    tradeJSONQuoted.executionRequest.bid == null ||
    tradeJSONQuoted.executionRequest.ask == undefined ||
    tradeJSONQuoted.executionRequest.ask == null
  ) {
    generateToastMessageForTradeFlowErrors({
      action: "quoteSynRepo",
      outcome: "missingSpreadTwoWay",
    });
    const cells = [];
    if (tradeJSONQuoted.executionRequest.bid == undefined || tradeJSONQuoted.executionRequest.bid == null) {
      cells.push({ esid: tradeJSONQuoted.esid, blockId: ER_LEVEL_FLASH_ID, field: "quote" as const, quoteSide: "bid" as const });
    }
    if (tradeJSONQuoted.executionRequest.ask == undefined || tradeJSONQuoted.executionRequest.ask == null) {
      cells.push({ esid: tradeJSONQuoted.esid, blockId: ER_LEVEL_FLASH_ID, field: "quote" as const, quoteSide: "ask" as const });
    }
    triggerValidationFlash(cells);
    return false;
  }
  return true;
}

export function quoteOutright(tradeJSONQuoted: any) {
  if (tradeJSONQuoted.blocks[0].quoteSide == QuoteSide.Bid) {
    if (
      tradeJSONQuoted.blocks[0].bid == undefined ||
      tradeJSONQuoted.blocks[0].bid == null
    ) {
      generateToastMessageForTradeFlowErrors({
        action: "quoteOutright",
        outcome: "noBidquoteSideER", // BID
      });
      triggerValidationFlash(returnMissingQuoteCellsFromTradeJSON(tradeJSONQuoted));
      return false;
    } else {
      return true;
      // True will trigger API call.
    }
  } else if (tradeJSONQuoted.blocks[0].quoteSide == QuoteSide.Ask) {
    if (
      tradeJSONQuoted.blocks[0].ask == undefined ||
      tradeJSONQuoted.blocks[0].ask == null
    ) {
      generateToastMessageForTradeFlowErrors({
        action: "quoteOutright",
        outcome: "noAskquoteSideER", // ASK
      });
      triggerValidationFlash(returnMissingQuoteCellsFromTradeJSON(tradeJSONQuoted));
      return false;
    } else {
      return true;
      // True will trigger API call.
    }
  }

  return false;
}
export function quoteValidationTwoWayOutright(tradeJSONQuoted: any) {
  // let returnValue = false;
  const outrightBlock = tradeJSONQuoted.blocks[0];

  if (
    outrightBlock.bid == undefined ||
    outrightBlock.bid == null ||
    outrightBlock.ask == undefined ||
    outrightBlock.ask == null
  ) {
    generateToastMessageForTradeFlowErrors({
      action: "quoteOutright",
      outcome: "missingSpreadTwoWay",
    });
    triggerValidationFlash(returnMissingTwoWayQuoteCellsFromTradeJSON(tradeJSONQuoted));
    return false;
  }
  return true;
}

export function quoteStructure(tradeJSONQuoted: any) {
  let spreadLevelQuotedCorrectly = true;
  // prevent the Quote form happening fromm incomplete spread
  if (
    (tradeJSONQuoted.executionRequest.quoteSideER == QuoteSide.Ask &&
      tradeJSONQuoted.executionRequest?.ask == undefined) ||
    (tradeJSONQuoted.executionRequest.quoteSideER == QuoteSide.Ask &&
      tradeJSONQuoted.executionRequest?.ask == null) || // Catch Null values too as the UI might return null instead of undefined.
    (tradeJSONQuoted.executionRequest.quoteSideER == QuoteSide.Bid &&
      tradeJSONQuoted.executionRequest?.bid == undefined) ||
    (tradeJSONQuoted.executionRequest.quoteSideER == QuoteSide.Bid &&
      tradeJSONQuoted.executionRequest?.bid == null)
  ) {
    // Spread not quoted but trade could still go ahead.
    spreadLevelQuotedCorrectly = false;
  }

  // prevent the Quote form happening from lack of block quotes
  const bothBlockValues = checkAllBlocksAreQuotedDetailedResult(tradeJSONQuoted);

  const allBlocksQuoted = bothBlockValues.areAllBlocksQuoted;
  const oneBlockWasQuoted = bothBlockValues.oneBlockWasQuoted;

  if (allBlocksQuoted || spreadLevelQuotedCorrectly) {
    return true; // True will trigger API call.
  } else {
    if (oneBlockWasQuoted) {
      generateToastMessageForTradeFlowErrors({
        action: "quoteStructure",
        outcome: "oneBlockWasQuoted",
      });
    } else {
      generateToastMessageForTradeFlowErrors({
        action: "quoteStructure",
        outcome: "noBlocksQuoted",
      });
    }
    triggerValidationFlash(returnMissingQuoteCellsFromTradeJSON(tradeJSONQuoted));
    return false;
  }
}
export function quoteValidationTwoWayStructureDirectionWithheld(
  tradeJSONQuoted: any,
) {
  let allBlocksQuoted = true;

  //TWO WAY Needs both bid and ask.
  tradeJSONQuoted.blocks.forEach((block: any) => {
    if (
      block.bid == null ||
      block.bid == undefined ||
      block.ask == null ||
      block.ask == undefined
    ) {
      allBlocksQuoted = false;
    }
  });

  let spreadLevelQuotedCorrectly = true;
  if (
    tradeJSONQuoted.executionRequest.bid == undefined ||
    tradeJSONQuoted.executionRequest.bid == null ||
    tradeJSONQuoted.executionRequest.ask == undefined ||
    tradeJSONQuoted.executionRequest.ask == null
  ) {
    spreadLevelQuotedCorrectly = false;
  }

  let allowQuote = false;
  if (spreadLevelQuotedCorrectly) {
    allowQuote = true;
  } else if (allBlocksQuoted) {
    allowQuote = true;
  }
  if (!allowQuote) {
    generateToastMessageForTradeFlowErrors({
      action: "quoteStructure",
      outcome: "missingSpreadTwoWay",
    });
    triggerValidationFlash(returnMissingTwoWayQuoteCellsFromTradeJSON(tradeJSONQuoted));
    return false;
  }

  return true;
}

export function quoteValidationTwoWayStructureDirectionShown(
  tradeJSONQuoted: any,
) {
  // prevent the Quote form happening fromm incomplete spread
  let spreadLevelQuotedCorrectly = true;
  if (
    tradeJSONQuoted.executionRequest.bid == undefined ||
    tradeJSONQuoted.executionRequest.bid == null ||
    tradeJSONQuoted.executionRequest.ask == undefined ||
    tradeJSONQuoted.executionRequest.ask == null
  ) {
    spreadLevelQuotedCorrectly = false;
  }

  // prevent the Quote form happening from lack of block quotes
  // Two-Way WITH Direction SHOWN needs both combos calculated.
  // Step 1 - Calculate the blocks of the direction the trade is in:
  const bothBlockValuesOfActualDirection =
    checkAllBlocksAreQuotedDetailedResult(tradeJSONQuoted);

  const allBlocksQuotedShownDirection =
    bothBlockValuesOfActualDirection.areAllBlocksQuoted;
  // Currently unused params.
  // let blocksLeftUnquotedShownDirection =
  //   bothBlockValuesOfActualDirection.amountOfBlocksLeftUnquoted;

  // Step 2 - Invert the block directions:
  const bothBlockValuesOfDirectionInverted = // 2 way specific
    checkAllBlocksAreQuotedDetailedResultInvertedForShownTwoWay(
      tradeJSONQuoted,
    );

  const allBlocksQuotedDirectionInverted =
    bothBlockValuesOfDirectionInverted.areAllBlocksQuoted;
  // Currently unused params.
  // let blocksLeftUnquotedDirectionInverted =
  //   bothBlockValuesOfDirectionInverted.amountOfBlocksLeftUnquoted;

  // If the spread is quoted, NO BLOCKS or any combo works.
  let allowQuote = false;
  if (spreadLevelQuotedCorrectly) {
    allowQuote = true;
  } else if (
    allBlocksQuotedShownDirection &&
    allBlocksQuotedDirectionInverted
  ) {
    // THIRD CONDITION - Can add logic for one missing spread and one missing block.
    // If 1 spread is quoted and there is 1 missing value from that side, AND the other side has no quoted spread BUT 0 missing block vlaues - the quote is good to go.
    allowQuote = true;
  }
  if (!allowQuote) {
    generateToastMessageForTradeFlowErrors({
      action: "quoteStructure",
      outcome: "noBlocksQuoted",
    });
    triggerValidationFlash(returnMissingTwoWayQuoteCellsFromTradeJSON(tradeJSONQuoted));
    return false;
  }

  return true;
}

// ----- ----- ----- ----- ----- ----- ----- ----- ----- ----- ----- ----- //
// ----- ----- ----- -----   EXECUTING   ----- ----- ----- ----- ----- ----- //
// ----- ----- ----- ----- ----- ----- ----- ----- ----- ----- ----- ----- //

export function executeSynRepo(tradeJSONQuoted: any) {
  // let isSpreadQuoted = true;

  if (tradeJSONQuoted.executionRequest.quoteSideER == QuoteSide.Ask) {
    if (
      tradeJSONQuoted.executionRequest.ask == undefined ||
      tradeJSONQuoted.executionRequest.ask == null
    ) {
      generateToastMessageForTradeFlowErrors({
        action: "executeSynRepo",
        outcome: "noAskquoteSideER", // ASK
      });
      triggerValidationFlash([{
        esid: tradeJSONQuoted.esid,
        blockId: ER_LEVEL_FLASH_ID,
        field: "quote",
        quoteSide: "ask",
      }]);
      // isSpreadQuoted = false;
      return false;
    }

    const areAllBlocksQuoted = checkAllBlocksAreQuoted(tradeJSONQuoted); // Function to loop over blocks

    if (!areAllBlocksQuoted) {
      generateToastMessageForTradeFlowErrors({
        action: "executeSynRepo",
        outcome: "allBlocksNotQuoted",
      });
      triggerValidationFlash(returnMissingQuoteCellsFromTradeJSON(tradeJSONQuoted));
      return false;
    } else {
      return true; // True will trigger API call.
    }
  } else if (tradeJSONQuoted.executionRequest.quoteSideER == QuoteSide.Bid) {
    if (
      tradeJSONQuoted.executionRequest.bid == undefined ||
      tradeJSONQuoted.executionRequest.bid == null
    ) {
      generateToastMessageForTradeFlowErrors({
        action: "executeSynRepo",
        outcome: "noBidquoteSideER", // BID
      });
      triggerValidationFlash([{
        esid: tradeJSONQuoted.esid,
        blockId: ER_LEVEL_FLASH_ID,
        field: "quote",
        quoteSide: "bid",
      }]);
      // isSpreadQuoted = false;
      return false;
    }
    const areAllBlocksQuoted = checkAllBlocksAreQuoted(tradeJSONQuoted); // Function to loop over blocks

    if (!areAllBlocksQuoted) {
      generateToastMessageForTradeFlowErrors({
        action: "executeSynRepo",
        outcome: "allBlocksNotQuoted",
      });
      triggerValidationFlash(returnMissingQuoteCellsFromTradeJSON(tradeJSONQuoted));
      return false;
    } else {
      return true; // True will trigger API call.
    }
  }
}
